import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Roofs extends Component {
  render() {
    return (
      <EntityList apiRoute='api/roofs' title='Remorque - Toits' editTitle='Toit' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Roofs;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/roofs.js
 **/